import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../features/auth/useUser';
import { useLogout } from '../../hooks/useLogout';
import { AuthBrandLogo } from '../../features/auth/AuthBrandLogo';
import './OnboardingPage.css';

export default function OrganizationSetupPage() {
  const navigate = useNavigate();
  const { user } = useUser();

  // 既存ユーザー（既に組織に所属しているユーザー）はトップページにリダイレクト
  useEffect(() => {
    if (user?.organization_id) {
      navigate('/', { replace: true });
    }
  }, [user, navigate]);

  const handleCreateOrganization = () => {
    navigate('/organizations/create');
  };

  const handleJoinOrganization = () => {
    navigate('/organizations/search');
  };

  const handleBack = () => {
    navigate('/onboarding');
  };

  const handleLogout = useLogout();

  return (
    <div className="auth-page">
      <div className="auth-container">
        <AuthBrandLogo />
        <div className="auth-card">
          <div className="auth-header">
            {user?.email && (
              <div className="user-info-block">
                <div className="user-email-badge">{user.email}</div>
                <button
                  type="button"
                  className="logout-link"
                  onClick={handleLogout}
                >
                  別のアカウントに切り替える
                </button>
              </div>
            )}
          </div>

          <div className="auth-content">
            <p className="auth-intro">
              新しい組織を作成するか、既存の組織に参加してください。
            </p>

            <div className="auth-options">
              <button
                type="button"
                className="auth-option"
                onClick={handleCreateOrganization}
              >
                <div className="option-icon">
                  <img src="/human_resources_hierarchy_1.svg" alt="組織作成" />
                </div>
                <h2 className="option-title">新しい組織を作成</h2>
                <p className="option-description">
                  あなたのチームや会社用の新しい組織を作成します。
                  あなたは自動的に管理者になります。
                </p>
              </button>

              <button
                type="button"
                className="auth-option"
                onClick={handleJoinOrganization}
              >
                <div className="option-icon">
                  <img src="/following_1.svg" alt="組織参加" />
                </div>
                <h2 className="option-title">既存の組織に参加</h2>
                <p className="option-description">
                  既存の組織に参加依頼を送信します。
                  管理者の承認後、アクセスできるようになります。
                </p>
              </button>
            </div>

            <div className="form-actions">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleBack}
              >
                戻る
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
